import axios from 'axios';
import { aesEncrypt } from './crypto';

// process.env.NODE_ENV === 'development' ? '/' : 'https://www.soqixi.com';
const baseURL = process.env.VUE_APP_BASE_URL;
console.log("VUE_APP_BASE_URL:",process.env.VUE_APP_BASE_URL);
const service = axios.create({
  baseURL: baseURL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json; charset=utf-8'
  }
});

service.interceptors.request.use(
  (config) => {
    const token = window.sessionStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `${token}`;
    }

    // ✅ 1. 加密GET请求参数（核心改造）
    if ((config.method === 'get' || config.method === 'delete' )&& config.params) {
      // 将原参数加密，只传 encryptData 到后端
      const encryptedParams = aesEncrypt(config.params);
      config.params = { encryptData: encryptedParams };
    }

    // ✅ 2. 加密POST/PUT/PATCH请求体（原有逻辑保留）
    if (['post', 'put', 'patch', 'delete'].includes(config.method) && config.data) {
      config.data = { encryptData: aesEncrypt(config.data) };
    }

    return config;
  },
  (error) => {
    console.error('请求拦截器错误：', error);
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('请求失败：', error);
    alert(`接口请求失败：${error.message || '未知错误'}`);
    return Promise.reject(error);
  }
);

export default service;